<mat-card-content class="p-y-24">
  <div class="row">
    <div class="col-sm-6">
      <app-user-profile-image [user]="user"></app-user-profile-image>
    </div>
    <div class="col-sm-6">
      <app-change-password></app-change-password>
    </div>
    <div class="col-12">
      <app-personal-details [user]="user"></app-personal-details>
    </div>
  </div>
</mat-card-content>
